import moment from "moment-timezone";

export const getPayload = jwt => {
    // A JWT has 3 parts separated by '.'
    // The middle part is a base64 encoded JSON
    // decode the base64
    let parsed = atob(jwt.split(".")[1]);
    if (typeof parsed !== "object") parsed = JSON.parse(parsed);
    return parsed;
};

export const getExpiry = token => {
    const payload = getPayload(token);
    const expiration = payload.exp;
    const currentTime = Date.now() / 1000 | 0
    return expiration - currentTime;
};
